//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {cloneDeep, isNumber, floor, isEmpty} from 'lodash';
import { SEARCH_MODE } from '@/utils/constant';

const defaultForm = {
  search_mode: 'vector',
  reranking_enable: false,
  reranking_mode: 'reranking_model',
  reranking_model: {
    reranking_provider_name: '',
    reranking_model_name: '',
  },
  weights: {
    fulltext_setting: {
      fulltext_weight: 30,
    },
    vector_setting: {
      vector_weight: 70,
    },
  },
  top_k: 2,
  score_threshold_enabled: false,
  score_threshold: '',
};


function numberValidator(rule, value, callback) {
  if(isNumber(value)) {
    callback();
  } else {
    callback('必须为数字');
  }
}

function parseJson(str, defaultValue) {
  try {
    const r = JSON.parse(str);
    return !isEmpty(r) ? r : defaultValue;
  } catch (e) {
    return defaultValue;
  }
}

export default {
  name: 'EditAgentAppDetail',
  data() {
    return {
      form: cloneDeep(defaultForm),
      rerankingModelList: [],
      rules: {
        search_mode: [
          { required: true, message: '请选择检索模式', trigger: 'change' },
        ],
        top_k: [
          { required: true, message: '请输入top k', trigger: 'blur' },
          { validator: numberValidator, trigger: 'blur' },
        ],
        'reranking_model.reranking_model_name': [
          { required: true, message: '请输入rerank模型', trigger: 'change' },
        ],
        score_threshold: [
          { required: true, message: '请输入score阈值', trigger: 'blur' },
          { validator: numberValidator, trigger: 'blur' },
        ],
      },
      SEARCH_MODE: cloneDeep(SEARCH_MODE),
    };
  },
  computed: {
    weightSlideMasks() {
      return {
        0: {
          style: {
            marginLeft: '50px',
            color: '#111',
          },
          label: `全文检索（${this.form?.weights?.fulltext_setting?.fulltext_weight || 0}）`,
        },
        1: {
          style: {
            right: '-140px',
            color: '#111',
          },
          label: `（${floor(1 - (this.form?.weights?.fulltext_setting?.fulltext_weight || 0), 1)}）语义`,
        },
      };
    },
    scoreSlideMasks() {
      return {
        0: {
          style: {
            top: '-50px',
            marginLeft: `${this.form.score_threshold * 100}%`,
            color: '#111',
          },
          label: this.form.score_threshold,
        },
        1: {
          label: ``,
        },
      };
    }
  },
  methods: {
    resetData(formData) {
      formData.reranking_model = parseJson(formData.reranking_model, cloneDeep(defaultForm.reranking_model));
      formData.weights = parseJson(formData.weights, cloneDeep(defaultForm.weights));
      return formData;
    },
    setFormData(formData) {
      this.$refs?.form?.clearValidate();
      if (formData) {
        const editFormData = this.resetData(cloneDeep(formData));
        const newFormData = cloneDeep(defaultForm);
        for(const k of Object.keys(newFormData)) {
          newFormData[k] = editFormData[k];
        }
        this.form = newFormData;
      }
      else {
        this.form = cloneDeep(defaultForm);
      }
      this.$nextTick(()=>{
        this.getModels('rerank', 'rerankingModelList');
      });
    },
    close() {
      this.$emit('close');
    },
    searchModeChange(v) {
      this.$set(this.form, 'reranking_enable', false);
      if(v === 'hybrid') {
        this.$set(this.form, 'reranking_mode', 'weighted_score');
      } else {
        this.$set(this.form, 'reranking_mode', 'reranking_model');
      }
    },
    rerankingModeChange(v) {
      if(v === 'weighted_score') {
        this.$set(this.form, 'reranking_enable', false);
      } else {
        this.$set(this.form, 'reranking_enable', true);
      }
    },
    async getModels(modelType, key) {
      try {
        const { models } = await this.$request({
          url: this.$api.listDefaultModels,
          data: {
            model_type: modelType,
          },
        });
        this[key] = models;
      } catch (err) {
        console.log(err);
        this[key] = [];
      }
    },
    // 通过modelName获取providerName
    getModelsProvider(key, modelName) {
      const list = this[key] || [];
      return list.find(item => (item.model_name === modelName))?.provider_name || '';
    },
    validate(callback){
      this.$refs.form.validate((valid) => {
        callback(valid);
      });
    },
    getFormData() {
      const formData = cloneDeep(this.form);
      if(!formData.reranking_enable) {
        formData.reranking_model = undefined;
      } else {
        formData.reranking_model = JSON.stringify({
          reranking_model_name: formData.reranking_model,
          reranking_provider_name: this.getModelsProvider('rerankingModelList', formData.reranking_model)
        });
      }
      if(formData.search_mode === 'hybrid') {
        formData.reranking_enable = true; // 混合检索模式，一定开启reranking
        if(formData.reranking_mode === 'weighted_score') {
          formData.reranking_model = undefined;
          const fullTextWeight = floor(formData.weights.fulltext_setting.fulltext_weight, 1);
          formData.weights = JSON.stringify({
            fulltext_setting: {
              fulltext_weight: fullTextWeight,
            },
            vector_setting: {
              vector_weight: floor(1 - fullTextWeight, 1),
            },
          });
        } else {
          formData.weights = undefined;
        }
      } else {
        formData.weights = undefined;
      }
      formData.top_k = parseInt(formData.top_k);
      formData.score_threshold = parseFloat(formData.score_threshold) || 0;
      return formData;
    },
  },
};
